import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider';
import ToastProvider from './components/ToastProvider';
import OfflineToast from './components/OfflineToast';
import Header from './components/Header';
import FeedGrid from './components/FeedGrid';
import Footer from './components/Footer';
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";


function App() {
  return (
    <Router>
      <div className="app-container flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow main-bg">
          <div className="content-wrapper">
            <Routes>
              <Route path="/" element={<Navigate to="/feed" replace />} />
              <Route path="/feed" element={<>
                
                <FeedGrid />
              </>} />
              <Route path="/privacypolicy" element={<PrivacyPolicy />} />
              <Route path="/tos" element={<TermsOfService />} />
              <Route path="*" element={<Navigate to="/feed" replace />} />
            </Routes>
          </div>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
